import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AutomationsDetailComponent } from './automations-detail/automations-detail.component';
import { AutomationsListComponent } from './automations-list/automations-list.component';

const routes: Routes = [
    {
        path: 'automations',
        children: [
            { path: '', component: AutomationsListComponent }
        ]
    },
    {
        path: 'automations/:id',
        children: [
            { path: '', component: AutomationsDetailComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AutomationsRoutingModule { }
